<template>
  <div class="text-left mb-3">
    <div class="d-flex align-items-center mb-2">
      <font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" />
      <v-label class="label-input">{{ label }}</v-label>
    </div>

    <v-text-field
      :name="name"
      :data-vv-as="(label || '').replace('*', '').trim()"
      :value="value"
      @input="$emit('input', $event)"
      v-validate="rules"
      outlined
      dense
      :loading="loading"
      :disabled="disabled"
    ></v-text-field>

    <span class="red--text">{{ validationErrors.first(name) }}</span>
  </div>
</template>

<script>
export default {
  name: "BaseInput",
  // Usa el validador del formulario que lo contiene, asi sus reglas (ej: required) bloquean el guardado
  inject: ["$validator"],
  props: {
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    rules: {
      type: String,
      default: "",
    },
    validationErrors: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
